export default "__VITE_ASSET__BVwpO3x$__"